module.exports = {"654323100":"福海镇","654323101":"喀拉玛盖镇","654323102":"解特阿热勒镇","654323201":"阔克阿尕什乡","654323202":"齐干吉迭乡","654323204":"阿尔达乡","654323400":"地区一农场","654323401":"福海监狱","654323500":"兵团一八二团","654323501":"兵团一八三团","654323502":"兵团一八七团","654323503":"兵团一八八团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654323.json
// module id = 3146
// module chunks = 0